<template>
  <div class="featured-properties container">
    <div class="columns">
      <div class="column is-12">
        <div class="header">
          <h2
            class="has-text-weight-bold has-text-centered is-size-2 is-size-5-mobile"
          >
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
            <span>Inmuebles destacados</span>
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
            <vue-fontawesome
              icon="star"
              class="star is-size-5 is-size-7-mobile"
            />
          </h2>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12 carousel-section">
        <card-slideshow :slides="featuredProperties">
          <template v-slot:slide="{ active, slide }">
            <router-link
              :to="{
                name: 'property-detail',
                params: { id: formatUrl(slide) }
              }"
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div
                class="p-t-md"
                :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                ]"
              >
                <a :href="href" target="_blank">
                  <property-card
                    class="property-card-hover"
                    :property="slide"
                    :active="active"
                  />
                </a>
              </div>
            </router-link>
          </template>
        </card-slideshow>
      </div>
    </div>
  </div>
</template>

<script>
import Properties from "@/services/properties";
import CardSlideshow from "@/components/CardSlideshow";
import PropertyCard from "@/components/PropertyCard";
import PropertyType from "@/constants/properties/ad-type";

export default {
  name: "FeaturedProperties",

  components: {
    CardSlideshow,
    PropertyCard
  },

  data() {
    return {
      indicator: true,
      indicatorInside: false,
      indicatorMode: "hover",
      indicatorStyle: "is-lines",
      featuredProperties: []
    };
  },

  beforeMount() {
    this.getFeaturedProperties();
  },

  methods: {
    getFeaturedProperties() {
      Properties.promoted().then(({ data: properties }) => {
        this.featuredProperties = properties;
        console.log("featured:::", this.featuredProperties);
      });
    },
    formatUrl(item) {
      let adTypeDesc = PropertyType.get[item.ad_type];
      let rooms = item.rooms;
      let roomType = "hab";
      if (rooms) {
        switch (item.use) {
          case "Local Comercial":
          case "Bodega":
            roomType = "esp";
            break;
          case "Oficina":
            roomType = "priv";
            break;
        }
      }
      let customUrl = `${adTypeDesc}-${item.use}`;
      if (rooms) {
        customUrl += `-${rooms}${roomType}`;
      }
      customUrl += `-${item.neighborhood}-${item.city}-${item.state}`;
      customUrl = customUrl
        .toLowerCase()
        .replaceAll(" ", "-")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let propertyIdUrl = `-I-${item.property_key}`;
      let encodedUrl = encodeURIComponent(customUrl + propertyIdUrl);
      return encodedUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-properties {
  padding: 1em;
  text-align: center;

  .header .stars svg {
    margin-right: 1em;
  }

  .star {
    margin-bottom: 0.25em;
    margin-right: 0.5em;
  }
  span {
    margin-right: 0.5em;
  }
}

.property-card-hover {
  transition: all 0.3s ease;
  &.active,
  &:hover {
    box-shadow: 10px 10px 10px 0 rgba(0, 0, 0, 0.45);
    transform: scale(1.01);
  }
}

@media only screen and (min-width: 769px) {
  .header {
    display: flex;
    height: 100%;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    text-align: left;

    .star {
      margin-bottom: 0.25em;
      margin-right: 1em;
    }
  }

  .carousel-section {
    // height: 700px;
    padding: 0;
  }
}
</style>
